import SignIn from "../../pages/publics/SignIn";

const AdminEntry = () => {
  // No need to check staff status here - let the admin views handle the validation
  // Users will be redirected to dashboard after successful login, and admin views will validate staff status

  return <SignIn isAdmin={true} />;
};

export default AdminEntry;
